import { render, staticRenderFns } from "./CreateCourseDialog.vue?vue&type=template&id=3e91ad00&scoped=true"
import script from "./CreateCourseDialog.vue?vue&type=script&lang=js"
export * from "./CreateCourseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e91ad00",
  null
  
)

export default component.exports